import { alphabetize } from "../mixins/utilities";

export const getError = state => {
  return state.fbError;
};
export const getGreetings = state => {
  return state.greetings.sort((a, b) => a.dateStart < b.dateStart);
};
export const getUser = state => {
  return state.user;
};
export const loading = state => {
  return state.setLoading;
};

export const getStudentsNames = state => {
  let arrActiveNames = alphabetize(state.students, "lname")
    .filter(el => el.isActive)
    .map(el => el.name);
  return arrActiveNames;
};

export const getStudents = state => {
  return state.students.sort((a, b) => a.lname > b.lname);
};

export const getActiveStudents = state => {
  let arrStudents = [];
  let objStudent = {};
  objStudent = {
    name: "all",
    userId: "all",
    lname: "aaab"
  };
  arrStudents.push(objStudent);
  objStudent = {
    name: "song for all",
    userId: "song for all",
    lname: "aaac"
  };
  arrStudents.push(objStudent);
  const arrActiveStudents = state.students
    .filter(el => el.isActive)
    .sort((a, b) => a.lname > b.lname);
  arrActiveStudents.forEach(el => {
    objStudent = {
      userId: el.userId,
      name: el.fname + " " + el.lname,
      lname: el.lname
    };
    arrStudents.push(objStudent);
  });
  return arrStudents;
};

export const getLoadedItem = state => {
  return state.loadedItem;
};
export const getStudentName = state => {
  return state.loadedStudentName;
};

export const getDisallowedDates = state => {
  var arr = [];
  for (var key in state.disallowedDates) {
    arr.push( state.disallowedDates[key]);
  };
  return arr
};

export const getStudentLessons = state => {
  let arrLessons = state.lessons.filter(
    el => el.studentId === state.user.userId
  );
  return arrLessons.sort((a, b) => a.date > b.date);
};

export const reservedLessonTimes = state => {
  let arr = [];
  state.lessons.forEach(el => {
    if (el.date === state.loadedLessonDate) {
      arr.push(el.lessonTime);
    }
  });
  return arr;
};

export const getSonglists = state => {
  return alphabetize(state.songlists, "name");
};

export const getLoadedSonglist = state => {
  return state.loadedSonglist;
};
